import axios from 'axios';

const authHeaders = () => ({
  Authorization: localStorage.getItem('token')
});

export const incomingShipmentApi = {
  getShipments: () => axios.get('/api/v1/admin/incoming-shipments', { headers: authHeaders() }),
  deleteShipment: shipmentId => axios.delete(`/api/v1/admin/incoming-shipments/${shipmentId}`, { headers: authHeaders() }),
  createShipment: (name) => axios.post('/api/v1/admin/incoming-shipments', { name }, { headers: authHeaders() }),
  /** Повна картка: expectedItems + scannedItems */
  getShipmentDetail: (shipmentId) => axios.get(`/api/v1/admin/incoming-shipments/${shipmentId}`, { headers: authHeaders() }),
  patchShipment: (shipmentId, status) => axios.patch(
    `/api/v1/admin/incoming-shipments/${shipmentId}`,
    { status },
    { headers: authHeaders() }
  ),
  patchExpectedItem: (shipmentId, expectedItemId, body) => axios.patch(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/${expectedItemId}`,
    body,
    { headers: authHeaders() }
  ),
  /** Надходження на склад: кількість і ціна закупки з рядка, як add-quantity в адмінці товарів. */
  postExpectedItemToSite: (shipmentId, expectedItemId) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/${expectedItemId}/post-to-site`,
    {},
    { headers: authHeaders() }
  ),
  /** Усі готові (повністю проскановані) позиції поставки — тип incoming_receipt_bulk в історії. */
  postAllReadyExpectedToSite: (shipmentId) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/post-all-ready-to-site`,
    {},
    { headers: authHeaders() }
  ),
  addExpectedItem: (shipmentId, body) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items`,
    body,
    { headers: authHeaders() }
  ),
  /** Якщо очікуваних ще немає — створити рядки з просканованих (без ціни закупки). */
  generateExpectedFromScanned: (shipmentId) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/from-scanned`,
    {},
    { headers: authHeaders() }
  ),
  patchExpectedItemPurchasePrice: (shipmentId, expectedItemId, purchasePrice) => axios.patch(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/${expectedItemId}/purchase-price`,
    { purchasePrice: purchasePrice == null ? null : purchasePrice },
    { headers: authHeaders() }
  ),
  deleteExpectedItem: (shipmentId, expectedItemId) => axios.delete(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/${expectedItemId}`,
    { headers: authHeaders() }
  ),
  /** Лише для позицій без product_id; інакше 400. Повертає оновлений список expectedItems. */
  patchExpectedItemBarcode: (shipmentId, expectedItemId, barcode) => axios.patch(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/${expectedItemId}/barcode`,
    { barcode: barcode == null || barcode === '' ? null : String(barcode).trim() },
    { headers: authHeaders() }
  ),
  /** Позиція без product_id: артикул з рядка записується в обраний товар, рядок прив'язується. Повертає expectedItems. */
  bindExpectedItemProduct: (shipmentId, expectedItemId, productId) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/${expectedItemId}/bind-product`,
    { productId },
    { headers: authHeaders() }
  ),
  excelImportMetadata: (shipmentId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/import-excel/metadata`, fd, {
      headers: { Authorization: localStorage.getItem('token') }
    });
  },
  excelImportColumns: (shipmentId, file, sheetIndex, headerRowIndex) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('sheetIndex', String(sheetIndex));
    fd.append('headerRowIndex', String(headerRowIndex));
    return axios.post(`/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/import-excel/columns`, fd, {
      headers: { Authorization: localStorage.getItem('token') }
    });
  },
  excelImportPreview: (shipmentId, formData) =>
    axios.post(`/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/import-excel/preview`, formData, {
      headers: { Authorization: localStorage.getItem('token') }
    }),
  excelImportApply: (shipmentId, formData) =>
    axios.post(`/api/v1/admin/incoming-shipments/${shipmentId}/expected-items/import-excel/apply`, formData, {
      headers: { Authorization: localStorage.getItem('token') }
    }),
  downloadSourceFile: (shipmentId, awsName) => axios.get(
    `/api/v1/admin/incoming-shipments/${shipmentId}/source-file` + (awsName ? `?awsName=${encodeURIComponent(awsName)}` : ''),
    { headers: authHeaders(), responseType: 'blob' }
  ),
  scanBarcode: (shipmentId, barcode) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/scan`,
    { barcode },
    { headers: authHeaders() }
  ),
  bindScannedItemProduct: (shipmentId, itemId, productId) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/scanned-items/${itemId}/bind-product`,
    { productId },
    { headers: authHeaders() }
  ),
  uploadScannedItemPhoto: (shipmentId, itemId, formData) => axios.post(
    `/api/v1/admin/incoming-shipments/${shipmentId}/scanned-items/${itemId}/photo`,
    formData,
    { headers: { Authorization: localStorage.getItem('token') } }
  ),
  deleteScannedItemPhoto: (shipmentId, itemId) => axios.delete(
    `/api/v1/admin/incoming-shipments/${shipmentId}/scanned-items/${itemId}/photo`,
    { headers: authHeaders() }
  ),
  updateScannedItemQuantity: (shipmentId, itemId, quantity) => axios.patch(
    `/api/v1/admin/incoming-shipments/${shipmentId}/scanned-items/${itemId}/quantity`,
    { quantity },
    { headers: authHeaders() }
  ),
  deleteScannedItem: (shipmentId, itemId) => axios.delete(
    `/api/v1/admin/incoming-shipments/${shipmentId}/scanned-items/${itemId}`,
    { headers: authHeaders() }
  )
};
